<template>
  <promised :promise="promise">
    <!-- Use the "pending" slot to display a loading message -->
    <template v-slot:pending>
      <p><v-progress-circular indeterminate /> Loading...</p>
    </template>
    <!-- The default scoped slot will be used as the result -->
    <template>
      <transition name="fade">
        <slot></slot>
      </transition>
    </template>
    <!-- The "rejected" scoped slot will be used if there is an error -->
    <template v-slot:rejected="error">
      <v-alert color="error" icon="warning" :value="error">
        We're sorry, we're not able to retrieve this information at the moment, please try back
        later.
        {{ error }}
      </v-alert>
    </template>
  </promised>
</template>
<script>
import {Promised} from 'vue-promised'

export default {
  props: ['promise'],
  components: {
    Promised,
  },
}
</script>
